
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aOGTc", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $cqmCC = parcelRequire("cqmCC");


var $aJv6Q = parcelRequire("aJv6Q");


var $bQm3c = parcelRequire("bQm3c");


var $7aRa9 = parcelRequire("7aRa9");


var $86okN = parcelRequire("86okN");


var $12UWa = parcelRequire("12UWa");


var $ccWUN = parcelRequire("ccWUN");

/* ArchivedPageBannerViewNote.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");







var $l1Ebn = parcelRequire("l1Ebn");

var $ecd190420d808d89$export$4a6bce095eaa04ed = /*#__PURE__*/ function(NoteViewState) {
    NoteViewState["COLLAPSED"] = "COLLAPSED";
    NoteViewState["EXPANDED"] = "EXPANDED";
    NoteViewState["CONTENT_FITS"] = "CONTENT_FITS";
    return NoteViewState;
}({});














const $f7a2182e4fa2be86$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    showMore: {
        id: "archive-pages.page-banner.note.actions.show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "archive-pages.page-banner.note.actions.show-less",
        defaultMessage: "Show less"
    },
    editNote: {
        id: "archive-pages.page-banner.note.actions.edit-note",
        defaultMessage: "Edit note"
    }
});
const $f7a2182e4fa2be86$export$17379e5368f92c9d = ({ noteViewState: noteViewState, setNoteViewState: setNoteViewState, userCanUpdateNote: userCanUpdateNote, openNoteCreation: openNoteCreation })=>{
    const expandNote = (0, $42omo.useCallback)(()=>{
        setNoteViewState((0, $ecd190420d808d89$export$4a6bce095eaa04ed).EXPANDED);
    }, [
        setNoteViewState
    ]);
    const collapseNote = (0, $42omo.useCallback)(()=>{
        setNoteViewState((0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED);
    }, [
        setNoteViewState
    ]);
    const getExpandCollapseButton = ()=>{
        if (noteViewState !== (0, $ecd190420d808d89$export$4a6bce095eaa04ed).CONTENT_FITS) {
            const [handleClick, buttonText] = noteViewState === (0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED ? [
                expandNote,
                $f7a2182e4fa2be86$export$a7357cdd1f0b0168.showMore
            ] : [
                collapseNote,
                $f7a2182e4fa2be86$export$a7357cdd1f0b0168.showLess
            ];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.ArchivePageActionLink), {
                onClick: handleClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), buttonText));
        }
        return null;
    };
    const getEditNoteButton = ()=>{
        if (userCanUpdateNote) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.ArchivePageActionLink), {
            onClick: openNoteCreation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f7a2182e4fa2be86$export$a7357cdd1f0b0168.editNote));
        return null;
    };
    const expandCollapseButton = getExpandCollapseButton();
    const editNoteButton = getEditNoteButton();
    if (!expandCollapseButton && !editNoteButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.NoteActionsWrapper), null, expandCollapseButton, expandCollapseButton && editNoteButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.HorizontalSeparator), null), editNoteButton);
};


const $1b09bd3fef175131$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    addNote: {
        id: "archive-pages.page-banner.note.actions.add-note",
        defaultMessage: "Add a note"
    }
});
const $1b09bd3fef175131$var$COMMENT_LINE_HEIGHT = 20;
const $1b09bd3fef175131$var$MAX_COLLAPSED_LINES = 3;
const $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT = $1b09bd3fef175131$var$COMMENT_LINE_HEIGHT * $1b09bd3fef175131$var$MAX_COLLAPSED_LINES; // need both -webkit-line-clamp AND height so that we get the trailing ellipsis AND the slide transition on expand.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b09bd3fef175131$var$NoteWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1reo15vq _18m915vq _v5648y7a _19pku2gc _1bto1l2s _1i4q1hna _sudp1e54 _1e0ccj1k",
            (__cmplp.height || 0) <= $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $1b09bd3fef175131$export$c6efa7a2c4cc7786 = ({ note: note, userCanUpdateNote: userCanUpdateNote, openNoteCreation: openNoteCreation })=>{
    const [noteViewState, setNoteViewState] = (0, $42omo.useState)((0, $ecd190420d808d89$export$4a6bce095eaa04ed).CONTENT_FITS);
    const noteRef = (0, $42omo.useRef)(null);
    const totalNoteHeight = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (noteRef.current) {
            totalNoteHeight.current = noteRef.current.scrollHeight;
            if (totalNoteHeight.current > $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT) setNoteViewState((0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED);
        }
    }, [
        noteRef,
        setNoteViewState
    ]);
    if (note) {
        const currentNoteHeight = noteViewState === (0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED ? $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT : totalNoteHeight.current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1b09bd3fef175131$var$NoteWrapper, {
            ref: noteRef,
            height: currentNoteHeight,
            "data-testid": "view-archive-note"
        }, note), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7a2182e4fa2be86$export$17379e5368f92c9d), {
            noteViewState: noteViewState,
            setNoteViewState: setNoteViewState,
            userCanUpdateNote: userCanUpdateNote,
            openNoteCreation: openNoteCreation
        }));
    }
    if (userCanUpdateNote) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.NoteActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.ArchivePageActionLink), {
        onClick: openNoteCreation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1b09bd3fef175131$export$a7357cdd1f0b0168.addNote)));
    return null;
};











var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $lkMYF = parcelRequire("lkMYF");




const $967ea6d7fdc7df40$var$wrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $967ea6d7fdc7df40$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    updateNote: {
        id: "archive-pages.page-banner.note.actions.update-note",
        defaultMessage: "Update"
    },
    saveNote: {
        id: "archive-pages.page-banner.note.actions.save-note",
        defaultMessage: "Add"
    },
    cancelSaveNote: {
        id: "archive-pages.page-banner.note.actions.cancel-note",
        defaultMessage: "Cancel"
    }
});
const $967ea6d7fdc7df40$var$ArchivedPageBannerEditNoteComponent = ({ defaultValue: defaultValue, onSave: onSave, onCancel: onCancel })=>{
    const createNoteRef = (0, $42omo.useRef)(null);
    const [isSaveDisabled, setIsSaveDisabled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        createNoteRef.current?.focus();
        // move cursor to the end of the textarea. its at the start by default.
        const noteLength = createNoteRef.current?.value?.length || 0;
        createNoteRef.current?.setSelectionRange(noteLength, noteLength);
    }, [
        createNoteRef
    ]);
    const handleSave = (0, $42omo.useCallback)(()=>{
        onSave(createNoteRef.current?.value || '');
    }, [
        onSave,
        createNoteRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $967ea6d7fdc7df40$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lkMYF.ArchivedPageNoteInput), {
        noteRef: createNoteRef,
        defaultValue: defaultValue,
        analyticsSource: "archiveList",
        onValidate: (isValid)=>{
            setIsSaveDisabled(!isValid);
        },
        isColorInverted: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.NoteActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.ArchivePageActionLink), {
        isDisabled: isSaveDisabled,
        onClick: handleSave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), defaultValue ? $967ea6d7fdc7df40$export$a7357cdd1f0b0168.updateNote : $967ea6d7fdc7df40$export$a7357cdd1f0b0168.saveNote)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.HorizontalSeparator), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1Ebn.ArchivePageActionLink), {
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $967ea6d7fdc7df40$export$a7357cdd1f0b0168.cancelSaveNote))));
};
const $967ea6d7fdc7df40$export$97bbfc8a7efe60a2 = $967ea6d7fdc7df40$var$ArchivedPageBannerEditNoteComponent;


const $154591b700ba0c88$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    createNoteErrorTitle: {
        id: "archive-pages.page-banner.note.creation.error.title",
        defaultMessage: "We couldn\u2019t add your note"
    },
    updateNoteErrorTitle: {
        id: "archive-pages.page-banner.note.update.error.title",
        defaultMessage: "We couldn\u2019t edit your note"
    },
    createNoteErrorDescription: {
        id: "archive-pages.page-banner.note.creation.error.description",
        defaultMessage: "Try again. If this keeps happening, contact {supportLink} or your space admin."
    },
    createNoteSuccessTitle: {
        id: "archive-pages.page-banner.note.creation.success.title",
        defaultMessage: "Note added"
    },
    updateNoteSuccessTitle: {
        id: "archive-pages.page-banner.note.update.success.title",
        defaultMessage: "Note edited"
    }
});
const $154591b700ba0c88$var$ArchivedPageBannerNoteComponent = ({ note: note, archiverAccountId: archiverAccountId, contentId: contentId, editingNote: editingNote, setEditingNote: setEditingNote, flags: flags })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [createOrUpdateNote, { error: noteCreationError }] = (0, $diswb.useMutation)((0, $eSUdr.default)`mutation ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation($pageId:Long!$archiveNote:String!){createOrUpdateArchivePageNote(pageId:$pageId archiveNote:$archiveNote)}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = cache.readQuery({
                query: (0, $86okN.toDocumentNode)((0, $ccWUN.default)),
                variables: {
                    contentId: contentId
                }
            });
            if (cachedData && responseData) {
                const copyOfCachedData = JSON.parse(JSON.stringify(cachedData));
                const contentNode = copyOfCachedData.content?.nodes?.[0];
                if (contentNode) {
                    contentNode.archivedContentMetadata = {
                        ...contentNode.archivedContentMetadata,
                        archiveNote: responseData.createOrUpdateArchivePageNote
                    };
                    cache.writeQuery({
                        query: (0, $86okN.toDocumentNode)((0, $ccWUN.default)),
                        variables: {
                            contentId: contentId
                        },
                        data: copyOfCachedData
                    });
                }
            }
        },
        onError: ()=>{
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), note ? $154591b700ba0c88$export$a7357cdd1f0b0168.updateNoteErrorTitle : $154591b700ba0c88$export$a7357cdd1f0b0168.createNoteErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$154591b700ba0c88$export$a7357cdd1f0b0168.createNoteErrorDescription,
                    values: {
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cqmCC.AtlassianSupportLink), null)
                    }
                })
            });
        }
    });
    const userCanUpdateNote = userId === archiverAccountId;
    const openNoteCreation = (0, $42omo.useCallback)(()=>{
        setEditingNote(true);
    }, [
        setEditingNote
    ]);
    const closeNoteCreation = (0, $42omo.useCallback)(()=>{
        setEditingNote(false);
    }, [
        setEditingNote
    ]);
    const handleSaveNote = (0, $42omo.useCallback)((newArchiveNote)=>{
        (0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'button',
            actionSubjectId: !note ? 'addArchiveNoteSubmitButton' : 'updateArchiveNoteSubmitButton',
            source: 'archivePageBanner',
            attributes: {
                includedNote: !!newArchiveNote
            }
        });
        createOrUpdateNote({
            variables: {
                // Casting as `any` to match original types from ../__types__/CreateOrUpdateArchivePageNoteMutation
                // Ideally pageId should be typed as ID
                pageId: contentId,
                archiveNote: newArchiveNote
            },
            optimisticResponse: {
                createOrUpdateArchivePageNote: newArchiveNote
            }
        });
        closeNoteCreation();
    }, [
        contentId,
        closeNoteCreation,
        createOrUpdateNote,
        createAnalyticsEvent,
        note
    ]);
    const renderNote = ()=>{
        if (editingNote) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $967ea6d7fdc7df40$export$97bbfc8a7efe60a2), {
            defaultValue: note,
            onSave: handleSaveNote,
            onCancel: closeNoteCreation
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b09bd3fef175131$export$c6efa7a2c4cc7786), {
            note: note,
            userCanUpdateNote: userCanUpdateNote,
            openNoteCreation: openNoteCreation
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, renderNote(), noteCreationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: noteCreationError
    }));
};
const $154591b700ba0c88$export$c47074c5933ae97d = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
})((0, $7aRa9.withFlags)($154591b700ba0c88$var$ArchivedPageBannerNoteComponent));
module.exports["i18n"] = $154591b700ba0c88$export$a7357cdd1f0b0168;
module.exports["ArchivedPageBannerNote"] = $154591b700ba0c88$export$c47074c5933ae97d;

});

parcelRegister("l1Ebn", function(module, exports) {
/* archivePageBannerNoteSharedStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6fnsQ = parcelRequire("6fnsQ");


var $cOrQJ = parcelRequire("cOrQJ");

const $970b1240ff8943ba$export$247376757894902 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _19pku2gc _1e0c1txw _4cvr1q9y",
            __cmplp.className
        ])
    });
});
const $970b1240ff8943ba$var$ArchivePageActionLinkAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $7sObp.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1o9zidpf _1e0c1o8l _k48pwu06 _1tjq1cj8 _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp?.isDisabled ? "_80om73ad" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $970b1240ff8943ba$export$d87e0a494deabb58 = ({ isDisabled: isDisabled = false, onClick: onClick, children: children, ...props })=>{
    const theme = (0, $cOrQJ.default)();
    // During dark-mode tokenization in CCECO-700 we were unable to identify an appropriate
    // design-system token to use to represent this color in such a way that had sufficient
    // contrast with the background colors available in both light and dark modes. As a
    // result we're leaving this as custom for now but adding it as a request to our design
    // team to identify the best path forward for this color.
    const getColor = ()=>{
        if (theme.colorMode === 'dark') return isDisabled ? (0, $6fnsQ.N500) : (0, $6fnsQ.B400);
        else return isDisabled ? (0, $6fnsQ.N80) : (0, $6fnsQ.B75);
    };
    const onClickInternal = (event)=>{
        if (!isDisabled) onClick?.(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($970b1240ff8943ba$var$ArchivePageActionLinkAnchor, {
        color: getColor(),
        isDisabled: isDisabled,
        "aria-disabled": isDisabled,
        onClick: onClickInternal,
        ...props
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $970b1240ff8943ba$var$Spacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8h8dc",
            __cmplp.className
        ])
    });
});
const $970b1240ff8943ba$export$a035dcf9055239cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($970b1240ff8943ba$var$Spacer, null, "\u2022");
module.exports["NoteActionsWrapper"] = $970b1240ff8943ba$export$247376757894902;
module.exports["ArchivePageActionLink"] = $970b1240ff8943ba$export$d87e0a494deabb58;
module.exports["HorizontalSeparator"] = $970b1240ff8943ba$export$a035dcf9055239cd;

});


//# sourceMappingURL=ArchivedPageBannerContent.abe5a9e2.js.map
